/**
 * @generated SignedSource<<a6146d83e6bd4550baf92d321251683d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type moreDropdown_AtlassianHubAppShell$data = {
  readonly customPages: ReadonlyArray<{
    readonly id: string;
    readonly name: {
      readonly default: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "moreDropdown_AtlassianHubAppShell";
};
export type moreDropdown_AtlassianHubAppShell$key = {
  readonly " $data"?: moreDropdown_AtlassianHubAppShell$data;
  readonly " $fragmentSpreads": FragmentRefs<"moreDropdown_AtlassianHubAppShell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "moreDropdown_AtlassianHubAppShell",
  "selections": [
    {
      "alias": "customPages",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "ids": [],
            "type": "CUSTOM"
          }
        }
      ],
      "concreteType": "HelpCenterPage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "concreteType": "HelpCenterPageName",
          "kind": "LinkedField",
          "name": "name",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "default"
            }
          ]
        }
      ],
      "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
    }
  ],
  "type": "HelpCenter"
};

(node as any).hash = "bdf2ee4c0e7d81a58ea6f6250d6f062a";

export default node;
